/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

const styles = {
  tag: css`
    background: rgb(243 245 249);
    box-shadow: none;
    border-radius: 3px;
    color: black;
    cursor: pointer;
    display: inline-block;
    font-weight: 500;
    margin-right: 5px;
    padding: 2px 6px;
    text-decoration: none;
    text-transform: capitalize;
  `,
};

type Props = {
  tag: string;
};

const Tag = ({ tag }: Props) => (
  <Button
    css={styles.tag}
    variant="secondary"
    size="small"
    component={TrackedLink2}
    href={`/tutorials?tag=${tag.toLowerCase()}`}
    trackingName="tutorial_tag"
  >
    {tag}
  </Button>
);

export default Tag;
